import {AxiosError} from 'axios';
import {GET_NON_NATIONAL_EXAM_WITHDRAWAL_REVIEW_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {GET_NON_NATIONAL_EXAM_WITHDRAWAL_REVIEW_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import {AddressItem} from '../../api/candidate/profile/@candidate/models';
import {EntityModelList} from '../../api/candidate/exam/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface WithdrawalReviewResponse {
  examLevel: string;
  levelSeekingAdmissionTo: string;
  reasonSelected: string;
  specifiedReason: string;
  fileNames: EntityModelList[];
  candidateDetails: {
    statutoryName: string;
    hanyuPinyinName: string;
    idType: string;
    nricFin: string;
    email: string;
    nationality: string;
    citizenship: string;
    schoolName: string;
    mailingAddress: AddressItem;
    foreignAddress1: string;
    foreignAddress2: string;
    foreignAddress3: string;
  };
  examYear: number;
  payNowProxyRequired?: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: WithdrawalReviewResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalExamWithdrawalReview = ({uuid, onSuccess, onError}: Input) => {
  const getNonNationalExamWithdrawalReview = async () => {
    const res = await axiosClient.get<WithdrawalReviewResponse>(
        GET_NON_NATIONAL_EXAM_WITHDRAWAL_REVIEW_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_NON_NATIONAL_EXAM_WITHDRAWAL_REVIEW_QUERY_KEY,
      getNonNationalExamWithdrawalReview,
      {
        onSuccess,
        onError,
      }
  );
};
